import { createContext, useContext, useState, useEffect, type ReactNode } from 'react';
import { getCachedAddress, clearCachedCredentials } from '../utils/passkey';

interface AuthContextType {
  passkeyAddress: `0x${string}` | null;
  setPasskeyAddress: (address: `0x${string}` | null) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [passkeyAddress, setPasskeyAddress] = useState<`0x${string}` | null>(null);

  // Load cached address on mount
  useEffect(() => {
    const cached = getCachedAddress();
    if (cached) {
      setPasskeyAddress(cached);
    }
  }, []);

  const logout = () => {
    clearCachedCredentials();
    setPasskeyAddress(null);
  };

  return (
    <AuthContext.Provider value={{ passkeyAddress, setPasskeyAddress, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
